// extracted by mini-css-extract-plugin
export default {"container":"I5IFO0gh","imageContainer":"US0gN70O","textBlockMargin":"cakIJXJR","fromBook":"wjdmRfq7","caption":"OiL5KkE1","credits":"m9jm8Onn"};